import React, { useEffect } from 'react';
import { playPrinter } from '../sfx';

export default function Receipt({ order, onClose }) {
  // Kick off the printer + tear sound as soon as a receipt is shown
  useEffect(() => {
    if (order) playPrinter();
  }, [order]);

  if (!order) return null;
  const { items = [], total = 0, when } = order;

  return (
    <div className="printer">
      <div className="printer-slot" />
      <div className="receipt-paper">
        <div className="receipt-inner">
          <div className="receipt-head">
            <div className="receipt-brand">Aina's Diner</div>
            <div className="receipt-sub">Order Confirmed</div>
            <div className="receipt-when">{when}</div>
          </div>

          <div className="receipt-dash" />

          <ul className="receipt-lines">
            {items.map((l, i) => (
              <li key={i}>
                <span className="ri-qty">{l.quantity}×</span>
                <span className="ri-name">{l.name}</span>
                <span className="ri-price">RM {(l.price * l.quantity).toFixed(2)}</span>
              </li>
            ))}
          </ul>

          <div className="receipt-dash" />

          <div className="receipt-total">
            <span>TOTAL</span>
            <span>RM {total.toFixed(2)}</span>
          </div>

          <div className="receipt-thanks">
            <div>Thank you! 💗</div>
            <div className="receipt-small">See you again soon</div>
          </div>

          <div className="receipt-barcode">
            {Array.from({ length: 34 }).map((_, i) => (
              <span key={i} style={{ width: `${1 + (i % 3)}px` }} />
            ))}
          </div>
        </div>
        <div className="receipt-tear" />
      </div>

      {onClose && (
        <button className="receipt-close" onClick={onClose}>
          New order
        </button>
      )}
    </div>
  );
}
